import React, { useMemo } from 'react';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { useDataGridDateRangeFilter } from '../../../../common/DataGrid/filters/useDataGridDateRangeFilter.jsx';
import {
  dataGridTextSorter,
  dataGridDateSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import PropTypes from 'prop-types';
import { Spinner } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';

const ArticlesTable = ({ articles, onDelete, onRowClick, onPreviewClick }) => {
  const { t } = useTranslation();

  const titleSkTextFilterProps = useDataGridTextFilter('title_sk');
  const titleEnTextFilterProps = useDataGridTextFilter('title_en');
  const createdDateRangeFilterProps = useDataGridDateRangeFilter('created_at');
  const locationSkTextFilterProps = useDataGridTextFilter('location_sk');
  const locationEnTextFilterProps = useDataGridTextFilter('location_en');

  const dataGridColumns = useMemo(
    () => [
      {
        title: t('Názov (slovensky)'),
        dataIndex: 'title_sk',
        ellipsis: true,
        sorter: dataGridTextSorter('title_sk'),
        defaultSortOrder: 'ascend',
        ...titleSkTextFilterProps,
      },
      {
        title: t('Názov (anglicky)'),
        dataIndex: 'title_en',
        ellipsis: true,
        sorter: dataGridTextSorter('title_en'),
        ...titleEnTextFilterProps,
      },
      {
        title: t('Pridaný'),
        dataIndex: 'created_at',
        sorter: dataGridDateSorter('created_at'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...createdDateRangeFilterProps,
        width: 170,
      },
      {
        title: t('Umiestnenie v SK menu'),
        dataIndex: 'location_sk',
        ellipsis: true,
        sorter: dataGridTextSorter('location_sk'),
        render: (location_sk) => location_sk || '-',
        ...locationSkTextFilterProps,
      },
      {
        title: t('Umiestnenie v EN menu'),
        dataIndex: 'location_en',
        ellipsis: true,
        sorter: dataGridTextSorter('location_en'),
        render: (location_en) => location_en || '-',
        ...locationEnTextFilterProps,
      },
    ],
    [
      t,
      titleSkTextFilterProps,
      titleEnTextFilterProps,
      createdDateRangeFilterProps,
      locationSkTextFilterProps,
      locationEnTextFilterProps,
    ],
  );

  if (!articles) {
    return <Spinner />;
  }
  const getDeleteQuestion = (record) => {
    const isInMenu = record.menu_items && record.menu_items.length > 0;

    if (isInMenu) {
      return t(
        'Chystáte sa odstrániť článok, ktorý sa nachádza v menu, chcete pokračovať?',
      );
    } else {
      return t(
        'Naozaj chcete vymazať tento článok? Operáciu nie je možné vrátiť späť.',
      );
    }
  };

  return (
    <>
      <DataGrid
        rowKey={(article) => article.id}
        columns={dataGridColumns}
        dataSource={articles || []}
        permissionsBasic={'articles'}
        uniqueTableId={'custom-pages-table'}
        onDelete={onDelete}
        customPreviewLabel={t('Zobraziť náhľad v slovenskej verzii')}
        onRowClick={onRowClick}
        onEditClick={onRowClick}
        onPreviewClick={onPreviewClick}
        seriousDeleteQuestion={getDeleteQuestion}
      />
    </>
  );
};

ArticlesTable.propTypes = {
  articles: PropTypes.array,
  onDelete: PropTypes.func,
  onRowClick: PropTypes.func,
  onPreviewClick: PropTypes.func,
};

export default ArticlesTable;
